/**
* @Author: zachalam
* @Date:   2017-02-01T14:03:21-08:00
* @Last modified by:   zachalam
* @Last modified time: 2017-02-01T14:03:21-08:00
*/


export const whoPays = (type) => {
  switch(type) {
    case 'you_pay':
      return "You'll pay for us.";
    case 'i_pay':
      return "I'll pay for us.";
    default:
      return "We'll split it 50/50."
  }
}



// WEBPACK FOOTER //
// ./src/mt.js